import React from "react";
import {
  HeroAuthorBase,
  Content,
  Image,
  AuthorInfo,
  AuthorSocialLinks,
} from "./hero-author.styled";
import { HeroAuthorSliceFragment } from "../../types/graphql";
import { SharedSliceType } from "../shared-slice/shared-slice";
import { SliceComponentProps } from "@prismicio/react";
import { Slice } from "@prismicio/types";
import { IPageContext } from "../../types/types";
import * as FA from "../../styles/fontawesome";

export type IHeroAuthorProps = Slice<
  SharedSliceType,
  HeroAuthorSliceFragment["primary"]
> & { type: SharedSliceType };

type SameAsLink = {
  same_as_link?: {
    url?: string;
  };
  link_type?: string;
};

const HeroAuthor = ({
  slice,
  context,
}: SliceComponentProps<IHeroAuthorProps, IPageContext>) => {
  const primary = slice.primary;
  const authorDoc = primary?.author?.document;
  const authorData = authorDoc && "data" in authorDoc && authorDoc?.data;

  const getSocialIcon = (icon: string) => {
    switch (icon) {
      case "LinkedIn":
        return FA.Linkedin_In;
      case "Twitter":
        return FA.Twitter;
      case "Instagram":
        return FA.Instagram;
      case "Facebook":
        return FA.Facebook;
      case "YouTube":
        return FA.Youtube;
      default:
        return [];
    }
  };

  const renderSocialLink = (link: SameAsLink) => {
    const socialIcon: string = link?.link_type || "";

    return socialIcon !== "meta" ? (
      <a href={link?.same_as_link?.url}>
        {link?.link_type && <i css={[...getSocialIcon(socialIcon)]}></i>}
      </a>
    ) : (
      <></>
    );
  };

  return (
    (authorDoc && authorData && (
      <HeroAuthorBase>
        <div className="container">
          <Content>
            {authorData.image?.url && (
              <Image
                src={authorData.image.url}
                alt={
                  authorData.image.alt ||
                  `${authorData.name} - Xometry Contributor`
                }
              />
            )}
            <AuthorInfo>
              <h1>{authorData.name}</h1>
              <p className="intro">{authorData.bio}</p>
              {authorData.same_as_links && authorData.same_as_links.length > 0 && (
                <AuthorSocialLinks>
                  {authorData.same_as_links.map((same_as_link, index) => (
                    <li key={index}>
                      {renderSocialLink(same_as_link as SameAsLink)}
                    </li>
                  ))}
                </AuthorSocialLinks>
              )}
            </AuthorInfo>
          </Content>
        </div>
      </HeroAuthorBase>
    )) || <></>
  );
};

export default HeroAuthor;
